import React, { useState } from 'react'; // <-- add useState
import { Link } from 'react-scroll';
import './css/Nav.css';

const SECTIONS = ['home', 'about', 'projects', 'contact'];

const Nav = ({ activeSection, onSetActive }) => {
  const [menuOpen, setMenuOpen] = useState(false); // <-- add this

  // New: helper to close menu after link click
  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Hamburger icon/button - only shown on mobile via CSS */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </div>
      {/* Main links, toggled by menuOpen */}
      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        {SECTIONS.map((section) => (
          <Link
            key={section}
            to={section}
            smooth={true}
            duration={500}
            offset={-70}
            spy={true}
            onSetActive={onSetActive}
            onClick={handleLinkClick}        // <-- add this to close on click
            className={`nav-link ${activeSection === section ? 'active' : ''}`}
          >
            {section.charAt(0).toUpperCase() + section.slice(1)}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Nav;
